import React from 'react';
export function SolutionIntro() {
  return <section className="w-full bg-[#000000] py-6 md:py-8 px-4 border-t border-gray-800" data-id="element-351">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-3" data-id="element-352">
        <h2 className="text-2xl md:text-3xl font-heading text-white font-[900] tracking-tight leading-tight" data-id="element-353">
          🧠 MEGAPACK AFRONTAR LA VEJEZ DE TUS PADRES
        </h2>

        <p className="italic text-sm md:text-base max-w-2xl text-[#EEEEEE]" data-id="element-354">
          Puedes seguir evitando decisiones...
        </p>

        <p className="text-yellow-400 font-bold md:text-xl font-heading tracking-tight text-[16px]" data-id="element-355">
          O puedes tener un sistema claro desde hoy
        </p>

        <div className="flex items-center justify-center gap-2 text-center max-w-2xl" data-id="element-356">
          <span className="text-xl flex-shrink-0" data-id="element-357">👉</span>
          <p className="text-white text-sm md:text-base font-medium" data-id="element-358">
            Acompañar esta etapa con claridad es posible
          </p>
        </div>
      </div>
    </section>;
}